import { ActionTypes } from "../constants";

export default function pricing(state = {}, action) {

  switch(action.type) {
    case ActionTypes.SET_PRICING_PLANS:
      return {
        ...state,
        plans: action.payload
      }
    case ActionTypes.SET_CURRENT_PLAN:
      return Object.assign({}, state, action.payload)
    default:
      return state;
  }
}